export default {
  VIEW_PERMISSION: "AdminPermission",
};
